import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from "./shared/shared.module";
import { AppRoutingModule } from './app-routing.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppComponent } from './app.component';
import { LoginComponent } from './auth/login/login.component';
import { ToastrModule } from 'ngx-toastr';

import { AuthService } from './shared/services/firebase/auth.service';
import { AdminGuard } from './shared/guard/admin.guard';
import { SecureInnerPagesGuard } from './shared/guard/SecureInnerPagesGuard.guard';
import { CookieService } from 'ngx-cookie-service';
import { AngularFireModule } from "@angular/fire";
import { AngularFireAuthModule } from "@angular/fire/auth";

import { environment } from '../environments/environment';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { InterceptorService } from './APIservices/middleware/interceptor.service';
import { LoginService } from './APIservices/registration/login.service';
import { ConfigService } from './APIservices/config.service';
import { CreateUserService } from './APIservices/users/create-user.service';
import { ListUserService } from './APIservices/users/list-user.service';
import { ListPermisionsService } from './APIservices/permisions/list-permisions.service';
import { ListRoleService } from './APIservices/role/list-role.service';
import { CreateRoleService } from './APIservices/role/create-role.service';
import { RoleUpdateDeleteService } from './APIservices/role/role-update-delete.service';
import { DndDirective } from './dnd.directive';
import { CreateBlogService } from './APIservices/blog/create-blog.service';
import { ListBlogService } from './APIservices/blog/list-blog.service';
import { CreateAttributesService } from './APIservices/cat/attributes/create-attributes.service';
import { CreateClassService } from './APIservices/cat/class/create-class.service';
import { CreateGroupService } from './APIservices/cat/group/create-group.service';
import { ListAttributesService } from './APIservices/cat/attributes/list-attributes.service';
import { ListClassService } from './APIservices/cat/class/list-class.service';
import { ListGroupService } from './APIservices/cat/group/list-group.service';
import { ListQuoteService } from './APIservices/quote/list-quote.service';
import { ListPagesService } from './APIservices/pages/list-pages.service';
import { ImageUploadService } from './APIservices/Cloudinary/image-upload.service';
import { AESService } from './APIservices/encryption/aes.service';
import { ListusersService } from './APIservices/training/listusers.service';
import { ResetpasswordService } from './APIservices/privacy/resetpassword.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AngularDraggableModule } from 'angular2-draggable';
import { DragulaModule } from 'ng2-dragula';
import { ListnewsService } from './APIservices/news/listnews.service';
import { CreatenewsService } from './APIservices/news/createnews.service';
import { NgxSpinnerModule } from 'ngx-spinner';
// import { ResetpasswordComponent } from './components/resetpassword/resetpassword.component';
// import { TraningComponent } from './components/traning/traning.component';
// import { EditcontactusComponent } from './pages/editcontactus/editcontactus.component';
// import { AddClassComponent } from './categories/add-class/add-class.component';
// import { Equip4saleComponent } from './equip4sale/equip4sale.component';
// import { AddProductComponent } from './e-commerce/add-product/add-product.component';
// import { ListcategoryComponent } from './categories/listcategory/listcategory.component';
// import { AddrolesComponent } from './components/roles/addroles/addroles.component';
// import { ProfileComponent } from './components/profile/profile.component';
//import {NgxPaginationModule} from 'ngx-pagination';
// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        DndDirective,
        // ResetpasswordComponent,
        // TraningComponent,
        // EditcontactusComponent,
        // AddClassComponent,
        // Equip4saleComponent,
        // AddProductComponent,
        // ListcategoryComponent,
        // AddrolesComponent,
        // ProfileComponent,
    ],
    imports: [
        // NgxPaginationModule,
        AngularDraggableModule,
        NgbModule,
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        SharedModule,
        AppRoutingModule,
        HttpClientModule,
        DragulaModule.forRoot(),
        ToastrModule.forRoot(),
        HttpClientModule,
        NgxSpinnerModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            },
        }),
        AngularFireModule.initializeApp(environment.firebase),
        AngularFireAuthModule,
        AngularFirestoreModule
    ],
    providers: [
        ResetpasswordService,
        ListnewsService,
        CreatenewsService,
        AESService,
        ListBlogService,
        ImageUploadService,
        ListPagesService,
        ListQuoteService,
        CreateAttributesService,
        CreateClassService,
        CreateGroupService,
        ListAttributesService,
        ListClassService,
        ListGroupService,
        ListBlogService,
        CreateBlogService,
        RoleUpdateDeleteService,
        ListPermisionsService,
        ListRoleService,
        CreateRoleService,
        AuthService,
        ListUserService,
        AdminGuard,
        SecureInnerPagesGuard,
        CookieService,
        LoginService,
        ConfigService,
        CreateUserService,
        ListusersService,
        {provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true},],
    exports: [
        DndDirective
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
